var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'nuxt-class-component';
import MapRoute from 'components/public/MapRoute.vue';
var Index = (function (_super) {
    __extends(Index, _super);
    function Index() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Index.prototype, "services", {
        get: function () {
            return [
                [
                    'transaction_services',
                    'distribution_qualifying',
                    'transport_of_furniture',
                    'trade_visits',
                    'transportation_of_materials',
                    'transportation_of_office_machinery',
                    'laboratory_transportation',
                    'gift_deliveries',
                    'pet_transportation',
                    'drugs_transportation_and_other_health_products'
                ],
                [
                    'courier_visits',
                    'suitcase_transportation',
                    'sample_transportation',
                    'transport_of_packages_documents_and_letters',
                    'laundry_transports',
                    'route_transports',
                    'food_transportation',
                    'transports_of_healthcare',
                    'pickup_and_export_of_spare_parts',
                    'webshop_retrieves'
                ]
            ];
        },
        enumerable: true,
        configurable: true
    });
    Index.prototype.go = function (route) {
        this.$router.push(route);
    };
    Index = __decorate([
        Component({
            middleware: 'auth',
            components: {
                'map-route': MapRoute
            }
        })
    ], Index);
    return Index;
}(Vue));
export default Index;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/tslint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/index.vue
// module id = ./node_modules/ts-loader/index.js!./node_modules/tslint-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/index.vue
// module chunks = 5